module.exports = __webpack_public_path__ + "img/bg-2.d3d61211.png";